import React from "react";
import { compose, withHandlers } from "recompose";
import { Table } from "reactstrap";
import classNames from "classnames";
import produce from "immer";
import {
  TableContainer,
  Pagination,
  TableDataFetch,
  withTable,
  ViewingRecords,
} from "components/common/Tables";
import download from "downloadjs";
import { Page, PendingButton } from "components/common";
import { formatCurrency } from "services/util";
import { Trans } from "react-i18next";

export const CustomerInvoiceList = ({
  match,
  url = "customer_invoices",
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  refreshToken,
  onGenerateInvoice,
  onSendInvoice,
}) => (
  <Page title="Invoices" className="inv-table">
    <TableContainer
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
    >
      <Table className="no-wrap text-center mt-4" responsive>
        <thead>
            <tr className="border-0">
                <th className="border-0"><Trans>Invoice</Trans></th>
                <th className="border-0"><Trans>Issue Date</Trans></th>
                <th className="border-0"><Trans>Due Date</Trans></th>
                <th className="border-0"><Trans>Sub Total</Trans></th>
                <th className="border-0"><Trans>Total Tax</Trans></th>
                <th className="border-0"><Trans>Total</Trans></th>
                <th className="border-0"><Trans>Paid?</Trans></th>
            </tr>
        </thead>
        {/* <thead>
          <tr>
            <th sortBy="invoice_number">
              <Trans>Invoice #</Trans>
            </th>
            <th sortBy="issue_date">
              <Trans>Issue Date</Trans>
            </th>
            <th sortBy="due_date">
              <Trans>Due Date</Trans>
            </th>
            <th className="text-right">
              <Trans>Sub Total</Trans>
            </th>
            <th className="text-right">
              <Trans>Total Tax</Trans>
            </th>
            <th className="text-right">
              <Trans>Total</Trans>
            </th>
            <th>
              <Trans>Paid?</Trans>
            </th>
            <th />
            <th />
          </tr>
        </thead> */}
        <tbody>
          {data.results.map((i, idx) => (
            <tr
              key={i.id}
              className={classNames({
                "table-success": i.paid,
              })}
            >
              <td>{i.invoice_number}</td>
              <td>{i.issue_date}</td>
              <td>{i.due_date}</td>
              <td className="text-right">
                {formatCurrency(i.sub_total)} {i.currency}
              </td>
              <td className="text-right">
                {formatCurrency(i.total_tax)} {i.currency}
              </td>
              <td className="text-right">
                {formatCurrency(i.total)} {i.currency}
              </td>
              <td>
                {i.paid ? (
                  <span className="fa fa-check-circle text-success" />
                ) : (
                  <span className="fa fa-times-circle text-danger" />
                )}
              </td>
              <td>
                {i.overdue && (
                  <span className="text-danger">
                    <Trans>Overdue</Trans>
                  </span>
                )}
              </td>
              <td className="text-end">
                <PendingButton
                  color="primary"
                  pending={i.pending}
                  onClick={() => onGenerateInvoice(idx)}
                  className="p-0 px-2"
                  size="sm"
                >
                  <span className="fa fa-download" />
                </PendingButton>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <div className="clearfix">
    <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />
    <div className="float-right">
      <Pagination
        size="sm"
        count={data.count}
        limit={limit}
        offset={offset}
        onOffsetChanged={setOffset}
      />
    </div>
    </div>
  </Page>
);

const enhance = compose(
  withTable({ limit: 100 }),
  withHandlers({
    onGenerateInvoice:
      ({ data, client, updateResults }) =>
      (idx) => {
        const results = data.results;
        const item = results[idx];

        updateResults(
          produce((draft) => {
            draft[idx].pending = true;
          })
        );

        client
          .post(`customer_invoices/${item.id}/generate_invoice`)
          .tap((resp) => {
            download(resp.data.content.replace(/\s/g, ""), resp.data.filename);
          })
          .finally(() => {
            updateResults(
              produce((draft) => {
                draft[idx].pending = false;
              })
            );
          });
      },
  })
);

export default enhance(CustomerInvoiceList);
